import { gql } from '@apollo/client';
import { ReviewedCountFragment } from '@/shared/api';

const HOLTER_RHYTHM_EVENTS_COUNT_QUERY = gql`
  query holterRhythmEventsCount($filter: HolterEventsFilter!) {
    holterRhythmEventsCount(filter: $filter) {
      isSuccess
      message
      afib ${ReviewedCountFragment}
      tachy ${ReviewedCountFragment}
      brady ${ReviewedCountFragment}
      pause ${ReviewedCountFragment}
      maxHr ${ReviewedCountFragment}
      minHr ${ReviewedCountFragment}
      vt ${ReviewedCountFragment}
      svt ${ReviewedCountFragment}
      avb2 ${ReviewedCountFragment}
      avb3 ${ReviewedCountFragment}
    }
  }
`;

export default HOLTER_RHYTHM_EVENTS_COUNT_QUERY;
